module.exports = __webpack_public_path__ + "ecosystem_go.37bcd658.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/ecosystem_go.png
// module id = 241
// module chunks = 0